// import React from "react";
// import { Route, Switch, useHistory } from "react-router-dom";
// import ReactTable from "./Reacttable/UserManagement/ReactTable";
// import Sidebar from "./Sidebar";

// //
// // import FilterKeyword from "./Filter/FilterKeyword";

// import TableComp from "./UserManagement/TableComp";
// import Test from "./UserManagement/Test";
// // import Oop from "./UserManagement/Oop";
// // import User from "./UserManagement/User";
// import UserManagementFile from "./UserManagement/UserManagementFile";
// // import Us from "./UserManagement/DeleteCarrierDatatable";
// import UserManagement from "./UserManagement/UserManagementFile";
// import UserTableMain from "./UserManagement/UserTableMain";
// import FilterKeyword from "../secure/Filter/FilterKeyword";
// // import SpamRules from "../secure/Filter/SpamRules";
// // import ChooseFile from "./blacklist/ChooseFile";
// // import BlackList from "./blacklist/BlackList";

// import AddReseller from "./UserManagement/AddReseller/AddReseller";
// import CreateContact from "./Contact/CreateContact";
// import ImportContact from "./Contact/ImportContact";
// import AddNewList from "./Contact/AddNewList";
// import ExportContact from "./Contact/ExportContact";
// import ManageBulkGroup from "./Contact/ManageBulkGroup";
// import AddContact from "./Contact/AddContact";

// // import SpamRules1 from "../secure/Filter/SpamRules1";

// import UpdatePassword from "./Update/UpdatePassword";
// import UpdateAccount from "./Update/UpdateAccount";
// import ResellerTable from "./UserManagement/ResellerTable";
// import CreateRule from "./RulesManagement/CreateRule";
// import RuleList from "./RulesManagement/RuleList";
// import MainBlacklisting from "./Blacklisting/MainBlacklisting";
// import MainWhitelisting from "./WhiteListing/MainWhitelisting";
// import NumberList from "./blacklist/NumberList";
// // import indexxx from "../test/indexxx";

// import ResellerSenderId from "./SenderId/Reseller Sender ID/ResellerSenderid";
// import ViewPendingSenderId from "./SenderId/Reseller Sender ID/ViewPendingSenderId";
// import AddSenderId from "./SenderId/Admin Sender ID/AdminSenderid";
// import ViewSenderId from "./SenderId/Admin Sender ID/ViewSenderId";
// // import AllBlack from "./blacklist/AllBlack ";/
// import AllBlack from "./blacklist/AllBlack";
// import AssignSenderId from "./SenderId/Admin Sender ID/AssignSenderId";
// import UserProfile from "./Reacttable/UserManagement/UserProfile";
// import Dashboard from "./Dashboard";
// import MainProfile from "./ProfileDetails/MainProfile";
// import Sendsms from "./SendSms/Sendsms";
// import SmsDelivery from "./SendSms/SmsDelivery";
// import ChangePassword from "./SendSms/ChangePassword";
// import TestTree from "./TestTree";
// import PageNotFound from "./PageNotFound";
// import OwnNumber from "./BaseManagement/OwnNumber";
// import TargetNumber from "./BaseManagement/TargetNumber";
// import TargetNumberDivision from "./BaseManagement/TargetNumberDivision";
// import TargetsiteCode from "./BaseManagement/TargetsiteCode";
// import Rewards from "./RewardsManagement/Rewards";
// import ResellerAdmin from "./RewardsManagement/ResellerAdmin";
// import AddTemplate from "./TemplateManagment/AddTemplate";
// import ViewTemplates from "./TemplateManagment/ViewTemplates";
// import UserTableApproved from "./Reacttable/UserManagement/UserNewModule.jsx/UserTableApproved";
// import RateCardManagement from "./RateCardManagement/ChannelTypeManagement";
// import ViewMediumManagement from "./RateCardManagement/MediumManagement/ViewMediumManagment";
// import ViewMeduimManagement from "./RateCardManagement/MediumManagement/ViewMediumManagment";

// // import SpamRules1 from "../secure/Filter/SpamRules1";

// // import indexxx from "../test/indexxx";

// // import SpamRules1 from "../secure/Filter/SpamRules1";

// // import indexxx from "../test/indexxx";

// export default function index(props) {
//   return (
//     <>
//       <Sidebar />
//       <Switch>
//         <Route path="/" exact component={Dashboard} />
//         <Route
//           path="/dashboard/ViewUser/Reseller"
//           exact
//           component={ReactTable}
//         />
//         <Route path="/dashboard/AddNewUser" exact component={AddReseller} />
//         <Route path="/dashboard/ViewUsers/approved" exact component={UserTableApproved} />

//         <Route path="/dashboard/UserDetail/:id" exact component={UserProfile} />
//         <Route path="/dashboard/menu3" exact component={ReactTable} />

//         <Route path="/tester" exact component={Test} />
//         <Route path="/dashboard/mainfile" exact component={UserTableMain} />

//         <Route
//           path="/dashboard/FilterKeyword"
//           exact
//           component={FilterKeyword}
//         />
//         <Route
//           path="/dashboard/UpdatePassword"
//           exact
//           component={UpdatePassword}
//         />
//         <Route
//           path="/dashboard/UpdateAccount"
//           exact
//           component={UpdateAccount}
//         />
//         <Route path="/dashboard/profile" exact component={MainProfile} />
//         <Route
//           path="/dashboard/ResellerInformation"
//           exact
//           component={ResellerTable}
//         />
//         <Route
//           // path="/dashboard/SpamManagement/SpamRules"

//           // path="/dashboard/SpamManagement/SpamRules"

//           path="/dashboard/UpdatePassword"
//           exact
//           component={UpdatePassword}
//         />
//         <Route
//           path="/dashboard/UpdateAccount"
//           exact
//           component={UpdateAccount}
//         />
//         <Route
//           path="/dashboard/ResellerInformation"
//           exact
//           component={ResellerTable}
//         />
//         {/* <Route path="/dashboard/blacklist" exact component={BlackList} /> */}
//         {/* <Route path="/dashboard/choosefile" exact component={ChooseFile} /> */}
//         <Route path="/dashboard/DND" exact component={AllBlack} />
//         <Route path="/dashboard/CreateRule" exact component={CreateRule} /> \
//         {/* <Route path="/dashboard/spam1" exact component={SpamRules1} /> */}
//         {/* <Route path="/dashboard/spam1" exact component={SpamRules1} /> */}
//         <Route path="/dashboard/ViewRule" exact component={RuleList} />
//         <Route
//           path="/dashboard/Blacklisting"
//           exact
//           component={MainBlacklisting}
//         />
//         <Route
//           path="/dashboard/Whitelisting"
//           exact
//           component={MainWhitelisting}
//         />
//         <Route path="/Number" exact component={NumberList} />
//         <Route path="/dashboard/AddSender-Ids" exact component={AddSenderId} />
//         <Route
//           path="/dashboard/ViewSender-Ids"
//           exact
//           component={ViewSenderId}
//         />
//         <Route
//           path="/dashboard/ViewResellersSender-Ids"
//           exact
//           component={ViewPendingSenderId}
//         />
//         {/* <Route
//             path="/dashboard/ViewSender"
//             exact
//             component={ViewPendingSenderId}
//           /> */}
//         <Route
//           path="/dashboard/Reseller/AddSender"
//           exact
//           component={ResellerSenderId}
//         />
//         <Route
//           path="/dashboard/AssignSender-Id"
//           exact
//           component={AssignSenderId}
//         />
//         <Route path="/dashboard/Sendsms" exact component={Sendsms} />
//         <Route path="/dashboard/Smsdelivery" exact component={SmsDelivery} />
//         <Route
//           path="/dashboard/ChangePassword"
//           exact
//           component={ChangePassword}
//         />
//         <Route path="/dashboard/ViewProfile" exact component={TestTree} />
//         <Route
//           path="/dashboard/OwnNumber"
//           exact
//           component={OwnNumber}
//         />
//         <Route
//           path="/dashboard/TargetNumber"
//           exact
//           component={TargetNumber}
//         />
//         <Route
//           path="/dashboard/TargetNumberDivision"
//           exact
//           component={TargetNumberDivision}
//         />
//         <Route
//           path="/dashboard/TargetSiteCode"
//           exact
//           component={TargetsiteCode}
//         />
//         <Route
//           path="/dashboard/Rewards"
//           exact
//           component={Rewards}
//         />
//         <Route
//           path="/dashboard/Payment"
//           exact
//           component={ResellerAdmin}
//         />
//         <Route
//           path="/dashboard/ManageTemplate/Addtemplate"
//           exact
//           component={AddTemplate}
//         />
//         <Route
//           path="/dashboard/ManageTemplate/ViewTemplate"
//           exact
//           component={ViewTemplates}
//         />
//         <Route
//           path="/dashboard/ChannelTypeManagement/Add"
//           exact
//           component={RateCardManagement}
//         />
//         <Route
//           path="/dashboard/MediumManagement/View"
//           exact
//           component={ViewMeduimManagement}
//         />
//                 <Route path="/dashboard/profile" exact component={MainProfile} />
//         <Route path="/dashboard/password" exact component={ChangePassword} />
//         <Route path="/dashboard/ CreateContact" exact component={CreateContact} />
//         <Route path="/dashboard/importcontact" exact component={ImportContact} />
//         <Route path="/dashboard/Newlist" exact component={AddNewList} />
//         <Route path="/dashboard/exportcontact" exact component={ExportContact} />
//         <Route path="/dashboard/Bukgroup" exact component={ManageBulkGroup} />
//         <Route path="/dashboard/addcontact" exact component={AddContact} />
//         <Route path="*" exact component={PageNotFound} />

//       </Switch>
//     </>
//   );
// }
import React from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import ReactTable from "./Reacttable/UserManagement/ReactTable";
import Sidebar from "./Sidebar";
import TableComp from "./UserManagement/TableComp";
import Test from "./UserManagement/Test";
import UserManagementFile from "./UserManagement/UserManagementFile";
import UserManagement from "./UserManagement/UserManagementFile";
import UserTableMain from "./UserManagement/UserTableMain";
import FilterKeyword from "../secure/Filter/FilterKeyword";
import AddReseller from "./UserManagement/AddReseller/AddReseller";
import ImportContact from "./Contact/ImportContact";
import ManageBulkGroup from "./Contact/ManageBulkGroup";
import AddContact from "./Contact/AddContact";
import UpdatePassword from "./Update/UpdatePassword";
import UpdateAccount from "./Update/UpdateAccount";
import ResellerTable from "./UserManagement/ResellerTable";
import CreateRule from "./RulesManagement/CreateRule";
import RuleList from "./RulesManagement/RuleList";
import MainBlacklisting from "./Blacklisting/MainBlacklisting";
import MainWhitelisting from "./WhiteListing/MainWhitelisting";
import NumberList from "./blacklist/NumberList";
import ResellerSenderId from "./SenderId/Reseller Sender ID/ResellerSenderid";
import ViewPendingSenderId from "./SenderId/Reseller Sender ID/ViewPendingSenderId";
import AddSenderId from "./SenderId/Admin Sender ID/AdminSenderid";
import ViewSenderId from "./SenderId/Admin Sender ID/ViewSenderId";
import AllBlack from "./blacklist/AllBlack";
import AssignSenderId from "./SenderId/Admin Sender ID/AssignSenderId";
import UserProfile from "./Reacttable/UserManagement/UserProfile";
import MainProfile from "./ProfileDetails/MainProfile";
import Sendsms from "./SendSms/Sendsms";
import SmsDelivery from "./SendSms/SmsDelivery";
import ChangePassword from "./SendSms/ChangePassword";
import TestTree from "./TestTree";
import OwnNumber from "./BaseManagement/OwnNumber";
import TargetNumber from "./BaseManagement/TargetNumber";
import TargetNumberDivision from "./BaseManagement/TargetNumberDivision";
import TargetsiteCode from "./BaseManagement/TargetsiteCode";
import Rewards from "./RewardsManagement/Rewards";
import ResellerAdmin from "./RewardsManagement/ResellerAdmin";
import AddTemplate from "./TemplateManagment/AddTemplate";
import ViewTemplates from "./TemplateManagment/ViewTemplates";
import UserTableApproved from "./Reacttable/UserManagement/UserNewModule.jsx/UserTableApproved";
import RateCardManagement from "./RateCardManagement/ChannelTypeManagement";
import Config from "./RewardsManagement/Config";
import MessageTypeManagement from "./RateCardManagement/MessageTypeManagement";
import RatesManagement from "./RateCardManagement/RatesManagement";
import AddMedium from "./RateCardManagement/MediumManagement/AddMedium";
import ViewMedium from "./RateCardManagement/MediumManagement/ViewMedium";
import Navbar from "./Navbar";
import PageNotFound from "./PageNotFound";
import Graphana from "./Graphana";
import DashboardTat from "./Dashboard/Dashboard";
import MainContact from "./Contact/MainContact";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import EditUser from "./Reacttable/UserManagement/EditUser";
import Dashboard from "./Dashboard/Dashboard";
import RoleManagement from "./RoleManagment/RoleManagement";
import VoiceCampaign from "./SendSms/VoiceCampaign";
import Settings from "./Settings/Settings";
import UserDashboard from "./Dashboard User/UserDashboard";
import ResellerDashboard from "./Dashboard Resseler/ResellerDashboard";
import AddNewList from "./Contact/AddNewList.jsx";
import VoiceCampaignData from "./SendSms/VoiceCampaignData";
import ShyamLala from "./RoleManagment/ShyamLala";
import UploadVoiceCampaign from "./SendSms/UploadVoiceCampaign";
import TransferList from "./RoleManagment/Delte";
import AddTemplateStatic from "./Template/Reseller_User/AddTemplateStatic";
import ViewTemplateReseller from "./Template/Reseller_User/ViewTemplateReseller";
import ViewTemplatesAdmin from "./Template/Admin/ViewTemplatesAdmin";
import UploaddVoiceeCampaign from "./SendSms/UploaddVoiceeCampaign";
import MainMaster from "./Master-section/Main-Master";
import ChannelManagement from "./Master-section/Channel-Management";
import Obd from "./Obd";
import AdminVoiceUploadsApproval from "./SendSms/Admin SendSms/AdminVoiceUploadsApproval";
import UserFilterTable from "./SendSms/UserFilterTable";
import AdminVoiceCreateApproval from "./SendSms/Admin SendSms/AdminVoiceCreateApproval";
import DefineSmsc from "./RouteManagment/Admin/DefineSmsc";
import ViewSmsc from "./RouteManagment/Admin/ViewSmsc";
import DefineRoute from "./RouteManagment/Admin/DefineRoute";
import ViewRoute from "./RouteManagment/Admin/ViewRoute";
import AlotRoute from "./RouteManagment/User_Reseller/AlotRoute";
import ViewRouteAlloted from "./RouteManagment/User_Reseller/ViewRouteAlloted";
import MainPhonebook from "./Contact/PhoneBook/MainPhonebook";
import UserFilterTable2 from "./SendSms/UserFilterTable2";
import DeliveryReport from "./Reports/DeliveryReports/DeliveryReports";
import VoiceCallerId from "./CallerId/Admin Caller Id/VoiceCallerId";
import CallerID from "./CallerId/ResellerUser Caller Id/CallerID";
import CampaignReports from "./Reports/CampaignWiseReports/CampaignReports";
import Revenue from "./Hello";
import CampaignDashboard from "./Dashboard Campaign/Dashboard/CampaignDashboard";
import ScheduledVoiceCampaign from "./Reports/ScheduledVoiceCampaignReports/ScheduledVoiceCampaign";
import ExportContact2 from "./Contact/ExportContact2";
import MainGroup from "./Contact/BulkGroup/MainGroup";
import ExportContactMultiSelect from "./Contact/ExportContactMultiSelect";
import ExportContact from "./Contact/ExportContact";
import ImportContactt2 from "./Contact/ImportContactt2";
import UserBaseRefund from "./RefundManagment/User_Reseller/UserBaseRefund";
import SomeFunctionalComponent from "./UserManagement/AdbLocker";
import Credit from "./CreditAllocation/Credit";
import MainCampaign from "./SendSms/CampaignManagerTable/MainCampaign";
import TransactionalReports from "./Reports/Transcational/TransactionalReports";
import DstReports from "./Reports/DstReports/DstReports";
import FortyEightHourReport from "./Reports/FortyEightHourReport/FortyEightHourReport";
import Discard from "./SendSms/CampaignManagerTable/Discard";
import RechargeReports from "./Reports/Recharge Reports/RechargeReports";
import TransactionalLineReports from "./Reports/MultlineReport/TransactionalLineReports";
import PieReports from "./Reports/PieReports/PieReports";
import TransactionalBarReports from "./Reports/MulitBarReport/TransactionalBarReports";
import TransactionalCardsReports from "./Reports/CardsReports/TransactionalCardsReports";
import CreateRule1 from "./RulesManagement/CreateRule1";
import MainAdminControl from "./SendSms/AdminCamapignControl/MainAdminControl";
import TransactionalCardsAll from "./Reports/CardsReports/TransactionalCardsAll";
import Activate from "./Filter/Activate";
import Deactivate from "./Filter/Deactivate";
import MainCredit from "./CreditAllocation/MainCredit";
import ViewCredit from "./CreditAllocation/ViewCredit";
import BlackOut from "./blacklist/BlackOut";
import SystemTps from "./Contact/TpsControl/SystemTps";
import UserTps from "./Contact/TpsControl/UserTps";
import DragandDrop from "./SendSms/DragandDrop";
import ViewLogs from "./Logs/ViewLogs";
// import OverviewFlow from "./ObdFlow/ReactFlow/Components/Flow";
import { MultipleFileUploadBasic } from "./SendSms/MultipleFileUploadBasic";
import { Successgraph } from "./Dashboard/Successgraph";
import DstReportss from "./Reports/DstReports/DstReportss";
import SuccessGraphReports from "./Dashboard/SucessGraphReports";
import SuccessGraphAll from "./Dashboard/SuccessGraphAll";
// import TransactionalReportBackup from "./Reports/Transcational/TransactionalReportBackup";
// import IpAdress from "./blacklist/IpAdress";
function index(props) {
  // console.log("TTTT", props.sectionClass);
  return (
    <>
      <Sidebar />
      <section
        // id="main-section-sidebar"
        className={props.sectionClass ? "ms-auto sec_1" : "ms-auto sec_2"}
        style={{ marginLeft: "auto", minHeight: "100vh" }}
      >
        <div className="home-content d-block">
          <Navbar />

          <Switch>
            {/* {JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
            "ROLE_SUPER_ADMIN" ? (
              <Route path="/" exact component={DashboardTat} />
            ) : JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
              "ROLE_RESELLER" ? (
              <Route path="/" exact component={DashboardTat} />
            ) : JSON.parse(localStorage.getItem("Sidebaritems"))?.name ==
              "ROLE_OBD_USER" ? (
              <Route path="/" exact component={CampaignDashboard} />
            ) : (
              <Route path="/" exact component={UserDashboard} />
            )} */}
            <Route path="/" exact component={DashboardTat} />

            <Route path="/dashboard/testingji" exact component={ShyamLala} />
            <Route path="/dashboard/AddAccount" exact component={AddReseller} />
            {/* <Route path="/IpAdress" exact component={IpAdress} /> */}

            <Route
              path="/dashboard/ViewUsers"
              exact
              component={UserTableApproved}
            />
            <Route
              path="/dashboard/DocumentVerification"
              exact
              component={ReactTable}
            />
            <Route
              path="/dashboard/ClientTreeView"
              exact
              component={TestTree}
            />
            {/* Phone */}
            <Route
              path="/dashboard/BlacklistLocal"
              exact
              component={MainBlacklisting}
            />
            <Route
              path="/dashboard/WhitelistLocal"
              exact
              component={MainWhitelisting}
            />
            {/* config */}
            <Route path="/dashboard/profile" exact component={MainProfile} />
            <Route
              path="/dashboard/BlacklistGlobalList"
              exact
              component={MainBlacklisting}
            />
            <Route
              path="/dashboard/WhitelistGlobalList"
              exact
              component={MainWhitelisting}
            />
            <Route path="/dashboard/DNDList" exact component={AllBlack} />
            {/* Rule Manager */}
            <Route path="/dashboard/AddRule" exact component={CreateRule1} />
            <Route path="/dashboard/ViewRule" exact component={RuleList} />
            {/* <Route
          path="/dashboard/ViewUsers"
          exact
          component={UserTableApproved}
        /> */}
            {/* Manage KeyWord */}
            <Route
              path="/dashboard/Managekeyword"
              exact
              component={FilterKeyword}
            />
            {/* Approval */}
            <Route path="/dashboard/SenderId" exact component={ViewSenderId} />
            {/* <Route path="/dashboard/Template" exact component={ViewTemplates} /> */}
            <Route
              path="/dashboard/MySenderid"
              exact
              component={ViewPendingSenderId}
            />
            {/* Reward */}
            <Route path="/dashboard/Dashboard" exact component={Rewards} />
            <Route path="/dashboard/ConfigRewards" exact component={Config} />
            {/* Contact */}
            {/* <Route path="/dashboard/AddContact" exact component={AddContact} /> */}
            <Route path="/dashboard/MyList" exact component={AddNewList} />
            {/* <Route
              path="/dashboard/ImportContacts"
              exact
              component={ImportContact}
            /> */}
            <Route path="/dashboard/MyContact" exact component={MainContact} />
            {/* Contact */}
            <Route path="/" exact component={Dashboard} />
            <Route
              path="/dashboard/ViewUser/Reseller"
              exact
              component={ReactTable}
            />
            <Route path="/dashboard/AddNewUser" exact component={AddReseller} />
            <Route path="/dashboard/EditUser/:id" exact component={EditUser} />
            <Route
              path="/dashboard/CampaignsControl"
              exact
              component={MainAdminControl}
            />
            {/* <Route path="/dashboard/transactional" exact component={TransactionalReportBackup} /> */}
            <Route path="/dashboard/Activate" exact component={Activate} />
            <Route path="/dashboard/Deactivate" exact component={Deactivate} />

            <Route
              path="/dashboard/ViewUsers/approved"
              exact
              component={UserTableApproved}
            />
            <Route
              path="/dashboard/UserDetail/:id"
              exact
              component={UserProfile}
            />
            <Route path="/dashboard/menu3" exact component={ReactTable} />
            <Route path="/tester" exact component={Test} />
            <Route path="/dashboard/mainfile" exact component={UserTableMain} />
            <Route
              path="/dashboard/FilterKeyword"
              exact
              component={FilterKeyword}
            />
            <Route
              path="/dashboard/UpdatePassword"
              exact
              component={UpdatePassword}
            />
            <Route
              path="/dashboard/UpdateAccount"
              exact
              component={UpdateAccount}
            />
            <Route path="/dashboard/profile" exact component={MainProfile} />
            <Route
              path="/dashboard/ResellerInformation"
              exact
              component={ResellerTable}
            />
            <Route
              // path="/dashboard/SpamManagement/SpamRules"

              // path="/dashboard/SpamManagement/SpamRules"

              path="/dashboard/UpdatePassword"
              exact
              component={UpdatePassword}
            />
            <Route
              path="/dashboard/UpdateAccount"
              exact
              component={UpdateAccount}
            />
            <Route
              path="/dashboard/ResellerInformation"
              exact
              component={ResellerTable}
            />
            {/* <Route path="/dashboard/blacklist" exact component={BlackList} /> */}
            {/* <Route path="/dashboard/choosefile" exact component={ChooseFile} /> */}
            <Route path="/dashboard/DND" exact component={AllBlack} />
            <Route path="/dashboard/CreateRule" exact component={CreateRule} />
            {/* <Route path="/dashboard/spam1" exact component={SpamRules1} /> */}
            {/* <Route path="/dashboard/spam1" exact component={SpamRules1} /> */}
            <Route path="/dashboard/ViewRule" exact component={RuleList} />
            <Route
              path="/dashboard/Blacklisting"
              exact
              component={MainBlacklisting}
            />
            <Route
              path="/dashboard/Whitelisting"
              exact
              component={MainWhitelisting}
            />
            <Route path="/Number" exact component={NumberList} />
            <Route
              path="/dashboard/AddSender-Ids"
              exact
              component={AddSenderId}
            />
            <Route
              path="/dashboard/ViewSender-Ids"
              exact
              component={ViewSenderId}
            />
            <Route
              path="/dashboard/ViewResellersSender-Ids"
              exact
              component={ViewPendingSenderId}
            />
            {/* <Route
            path="/dashboard/ViewSender"
            exact
            component={ViewPendingSenderId}
          /> */}
            <Route
              path="/dashboard/CreateSenderId"
              exact
              component={ResellerSenderId}
            />
            <Route
              path="/dashboard/AssignSender-Id"
              exact
              component={AssignSenderId}
            />
            {/* paras routes here */}
            <Route path="/dashboard/SmsCampaign" exact component={Sendsms} />
            <Route
              path="/dashboard/Smsdelivery"
              exact
              component={SmsDelivery}
            />
            <Route
              path="/dashboard/VoiceCampaign"
              exact
              component={VoiceCampaign}
            />
            <Route
              path="/dashboard/VoiceCampaignTable"
              exact
              component={VoiceCampaignData}
            />
            <Route
              path="/dashboard/AddPrompts"
              exact
              component={UploaddVoiceeCampaign}
            />
            <Route
              path="/dashboard/VoiceApproval"
              exact
              component={AdminVoiceUploadsApproval}
            />
            <Route
              path="/dashboard/VoiceApproval"
              exact
              component={AdminVoiceUploadsApproval}
            />
            <Route
              path="/dashboard/DeliveryReport"
              exact
              component={DeliveryReport}
            />
            <Route
              path="/dashboard/MyVoiceFiles"
              exact
              component={UserFilterTable}
            />
            <Route
              path="/dashboard/ViewVoiceCampaigns"
              exact
              component={UserFilterTable2}
            />
            <Route
              path="/dashboard/Campaign"
              exact
              component={AdminVoiceCreateApproval}
            />
            {/* paras routes here  */}
            <Route
              path="/dashboard/ChangePassword"
              exact
              component={ChangePassword}
            />
            <Route path="/dashboard/ViewProfile" exact component={TestTree} />
            <Route path="/dashboard/OwnNumber" exact component={OwnNumber} />
            <Route
              path="/dashboard/TargetBase"
              exact
              component={TargetNumber}
            />
            <Route
              path="/dashboard/TargetNumberDivision"
              exact
              component={TargetNumberDivision}
            />
            <Route
              path="/dashboard/TargetSiteCode"
              exact
              component={TargetsiteCode}
            />
            <Route path="/dashboard/Rewards" exact component={Rewards} />
            <Route path="/dashboard/Payment" exact component={ResellerAdmin} />
            <Route
              path="/dashboard/ManageTemplate/Addtemplate"
              exact
              component={AddTemplate}
            />
            <Route
              path="/dashboard/48HourReport/All"
              exact
              component={DstReports}
            />
            <Route
              path="/dashboard/TransactionalReport/All"
              exact
              component={DstReportss}
            />
            <Route
              path="/dashboard/TransactionalReports/All"
              exact
              component={DstReports}
            />
            <Route
              path="/dashboard/ManageTemplate/ViewTemplate"
              exact
              component={ViewTemplates}
            />
            {/* Rate Card */}
            <Route
              path="/dashboard/SmsPackage"
              exact
              component={RateCardManagement}
            />
            <Route
              path="/dashboard/MessageTypeManagement/Messages"
              exact
              component={MessageTypeManagement}
            />
            <Route
              path="/dashboard/AddRateCard"
              exact
              component={RatesManagement}
            />
            <Route
              path="/dashboard/MediumCardManagement/AddMedium"
              exact
              component={AddMedium}
            />
            <Route
              path="/dashboard/MediumCardManagement/ViewMedium"
              exact
              component={ViewMedium}
            />
            {/* rate Card */}
            {/* rolemanagement */}
            <Route
              path="/dashboard/ManageRole"
              exact
              component={RoleManagement}
            />
            {/* rolemanaghement */}
            <Route path="/dashboard/profile" exact component={MainProfile} />
            <Route
              path="/dashboard/password"
              exact
              component={ChangePassword}
            />
            <Route
              path="/dashboard/importcontact"
              exact
              component={ImportContact}
            />
            <Route path="/dashboard/Newlist" exact component={AddNewList} />
            <Route
              path="/dashboard/exportcontact"
              exact
              component={ExportContact2}
            />
            <Route
              path="/dashboard/ExportContacts"
              exact
              component={ExportContact}
            />
            <Route
              path="/dashboard/ImportContacts"
              exact
              component={ImportContactt2}
            />
            <Route
              path="/dashboard/Bukgroup"
              exact
              component={ManageBulkGroup}
            />
            {/* <Route path="/dashboard/ImportContacts" exact component={ImporttContact22}/> */}
            {/* <Route path="/dashboard/addcontact" exact component={AddContact} /> */}
            <Route path="/dashboard/test" exact component={Graphana} />
            <Route path="/Settings" exact component={Settings} />
            {/* <Route path="/role" exact component={RolesShbhit} /> */}
            {/* <Route path="/role12" exact component={RoleShobit} /> */}
            {/* <Route path="/dashboard/ViewUsers" exact component={ReactTable} /> */}
            <Route path="/off" exact component={TransferList} />
            <Route path="/dashboard/BlackOutTime" exact component={BlackOut} />

            {/* anmol templates */}
            <Route
              path="/dashboard/MyTemplate"
              exact
              component={ViewTemplateReseller}
            />
            <Route
              path="/dashboard/TransactionalReports"
              exact
              component={TransactionalLineReports}
            />
            <Route
              path="/dashboard/CreateTemplate"
              exact
              component={AddTemplateStatic}
              // component={ViewTemplateReseller}
            />
            <Route
              path="/dashboard/Template"
              exact
              component={ViewTemplatesAdmin}
            />
            {/* anmol routees */}
            {/* SHYAM BIR ROPUTES */}
            <Route path="/dashboard/AddPackage" exact component={MainMaster} />
            <Route
              path="/dashboard/ViewPackage"
              exact
              component={ChannelManagement}
            />
            {/* SHYAM BIR ROUTES */}
            {/* contact */}
            <Route
              path="/dashboard/MyPhonebook"
              exact
              component={MainPhonebook}
            />
            <Route path="/dashboard/MyBulkGroup" exact component={MainGroup} />
            {/* contact */}
            {/* anmol routes management */}
            <Route
              path="/dashboard/DefineSmsc"
              exact
              component={DefineSmsc}
              // component={ViewTemplateReseller}
            />
            {/* <Route
              path="/dashboard/DstReport/All/:id"
              exact
              component={DstReports}
            /> */}

            <Route
              path="/dashboard/ViewSmsc"
              exact
              component={ViewSmsc}
              // component={ViewTemplateReseller}
            />
            <Route
              path="/dashboard/DefineRoute"
              exact
              component={DefineRoute}
              // component={ViewTemplateReseller}
            />
            <Route
              path="/dashboard/ViewRoute"
              exact
              component={ViewRoute}
              // component={ViewTemplateReseller}
            />
            <Route
              path="/dashboard/AllotRoute"
              exact
              component={AlotRoute}
              // component={ViewTemplateReseller}
            />
            <Route
              path="/dashboard/ViewAssignedRoute"
              exact
              component={ViewRouteAlloted}
              // component={ViewTemplateReseller}
            />
            {/* anmol route mngnt */}
            {/* Reports routes */}
            <Route
              path="/dashboard/TransactionalReport"
              exact
              component={TransactionalReports}
            />
            <Route
              path="/dashboard/DstReport/:id"
              exact
              component={DstReports}
            />
            <Route
              path="/dashboard/48HourReport"
              exact
              component={FortyEightHourReport}
            />
            <Route
              path="/dashboard/ScheduledVoiceCampaignReport"
              exact
              component={ScheduledVoiceCampaign}
            />
            <Route
              path="/dashboard/VoiceCampaignReport"
              exact
              component={DeliveryReport}
            />
            <Route
              path="/dashboard/Rechargereport"
              exact
              component={RechargeReports}
            />
            {/* <Route path="/dashboard/AllocateCredit" exact component={Credit} /> */}
            <Route path="/dashboard/AddCredit" exact component={MainCredit} />
            <Route path="/dashboard/ViewCredit" exact component={ViewCredit} />

            {/* <Route
              path="/dashboard/CampaignReport"
              exact
              component={CampaignReports}
            /> */}
            {/* Reports routes */}
            {/* caller id status */}
            <Route
              path="/dashboard/Caller-IdApproval"
              exact
              component={VoiceCallerId}
            />
            <Route path="/Revenue" exact component={Revenue} />
            <Route path="/dashboard/MyCallerId" exact component={CallerID} />
            {/* caller id status */}
            <Route
              path="/dashboard/CampaignControl"
              exact
              component={MainCampaign}
            />
            <Route path="/discard" exact component={Discard} />

            {/* refund managment */}

            <Route
              path="/dashboard/UserBaseRefund"
              exact
              component={UserBaseRefund}
            />
            {/* refund managment */}
            <Route path="/siesta" exact component={Obd} />

            <Route
              path="/dashboard/TransactionalReports"
              exact
              component={TransactionalLineReports}
            />
            <Route
              path="/dashboard/Dashboardreport"
              exact
              component={TransactionalBarReports}
            />
                 <Route
              path="/dashboard/SuccessGraph"
              exact
              component={Successgraph}
            />
                   <Route
              path="/dashboard/FailedGraph"
              exact
              component={Successgraph}
            />
            <Route
              path="/dashboard/Dashboardreports"
              exact
              component={PieReports}
            />
            <Route
              path="/dashboard/DashboardReportss"
              exact
              component={TransactionalCardsReports}
            />
            <Route
              path="/dashboard/SuccessGraph/SuccessGraphReports"
              exact
              component={SuccessGraphReports}
            />
               <Route
              path="/dashboard/FailedGraph/FailedGraphReports"
              exact
              component={SuccessGraphReports}
            />
              <Route
              path="/dashboard/SuccessGraphAll"
              exact
              component={SuccessGraphAll}
            />
              {/* <Route
              path="/dashboard/FailedGraph/FailedGraphAll"
              exact
              component={SuccessGraphAll}
            /> */}
            <Route path="/dashboard/SystemTps" exact component={SystemTps} />
            <Route path="/dashboard/UserTps" exact component={UserTps} />
            <Route path="/draganddrop" exact component={DragandDrop} />
            <Route
              path="/dashboard/DashboardReportss/All"
              exact
              component={TransactionalCardsAll}
            />
            <Route path="/dashboard/AdvanceSearch" exact component={ViewLogs} />
            <Route path="/multi" exact component={MultipleFileUploadBasic} />

            {/* <Route path="/dashboard/Flow" exact component={OverviewFlow} /> */}
            <Route path="*" exact component={PageNotFound} />
            {/* {JSON.parse(localStorage.getItem("Sidebaritems")).name ==
            "ROLE_SUPER_ADMIN" ? (
              <>
                <Route path="/" exact component={DashboardTat} />
                <Route path="/dashboard" exact component={DashboardTat} />
               
              </>
            ) : JSON.parse(localStorage.getItem("Sidebaritems")).name ==
              "ROLE_RESELLER" ? (
              <>
                <Route path="/" exact component={ResellerDashboard} />
                <Route path="/dashboard" exact component={ResellerDashboard} />
               
              </>
            ) : (
              <>
                <Route path="/" exact component={UserDashboard} />
                <Route path="/dashboard" exact component={UserDashboard} />
              
              </>
            )} */}
          </Switch>
        </div>
      </section>
    </>
  );
}

const mapStateToProps = (state) => ({
  sectionClass: state.sidebarReducer.sectionClass,
});

export default connect(mapStateToProps)(index);
